import React from 'react';

const DownloadIcon = (props: any) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <path
        d='M13 6L13 14.5869L15.2939 12.293C15.6845 11.9025 16.3175 11.9025 16.708 12.293C17.0985 12.6835 17.0985 13.3165 16.708 13.707L12.707 17.707L12.6309 17.7754C12.2381 18.0957 11.6591 18.0731 11.293 17.707L7.29199 13.707L7.22363 13.6309C6.9033 13.2381 6.92595 12.6591 7.29199 12.293C7.65811 11.9269 8.23711 11.9042 8.62988 12.2246L8.70605 12.293L11 14.5869L11 6C11 5.44771 11.4477 5 12 5C12.5523 5 13 5.44771 13 6ZM5 21L4.89746 20.9951C4.39332 20.9438 4 20.5177 4 20C4 19.4823 4.39332 19.0562 4.89746 19.0049L5 19H19.001C19.5533 19 20.001 19.4477 20.001 20C20.001 20.5523 19.5533 21 19.001 21L5 21Z'
        fill='#ffffff'
      />
    </svg>
  );
};

export default DownloadIcon;
